import { Pipe, PipeTransform } from '@angular/core';
import { CatalogTagModel } from 'src/app/views/models/allergen.model';
import { MenuTagModel } from 'src/app/views/models/menu-tag.model';

@Pipe({
  name: 'tagExist'
})
export class TagExistPipe implements PipeTransform {

  transform(tags: MenuTagModel[], name: string): boolean {

    const EXIST = tags.find(TAG => {
      try {
        const VALUE: CatalogTagModel = JSON.parse(TAG.name);
        return VALUE.name === name;
      } catch {
        return false;
      }
    });

    return !(EXIST);
  }

}
